import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function BulkEditModal({ open, onOpenChange, columns, count, onApply }) {
  const editable = columns.filter((c) => c.key !== "id");
  const [field, setField] = useState("");
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setField("");
      setValue("");
    }
  }, [open]);

  const col = editable.find((c) => c.key === field);

  const apply = async () => {
    if (!field) return;
    setSaving(true);
    await onApply(field, value);
    setSaving(false);
    onOpenChange(false);
  };

  const renderValueInput = () => {
    if (!col) return null;
    if (col.type === "select") {
      return (
        <Select value={value} onValueChange={setValue}>
          <SelectTrigger data-testid="bulk-edit-value">
            <SelectValue placeholder="Değer seçiniz" />
          </SelectTrigger>
          <SelectContent>
            {(col.options || []).map((o) => (
              <SelectItem key={o.value} value={o.value}>
                {o.value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    if (col.type === "textarea") {
      return (
        <Textarea value={value} onChange={(e) => setValue(e.target.value)} rows={3} data-testid="bulk-edit-value" />
      );
    }
    const t = col.type === "number" ? "number" : col.type === "date" ? "date" : "text";
    return <Input type={t} value={value} onChange={(e) => setValue(e.target.value)} data-testid="bulk-edit-value" />;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="bulk-edit-modal">
        <DialogHeader>
          <DialogTitle>Toplu Düzenle</DialogTitle>
          <DialogDescription>
            Seçili <b>{count}</b> kaydın bir alanını aynı değerle güncelleyin.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Alan</Label>
            <Select value={field} onValueChange={(v) => { setField(v); setValue(""); }}>
              <SelectTrigger data-testid="bulk-edit-field">
                <SelectValue placeholder="Sütun seçiniz" />
              </SelectTrigger>
              <SelectContent className="max-h-72">
                {editable.map((c) => (
                  <SelectItem key={c.key} value={c.key}>
                    {c.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {field && (
            <div className="space-y-1.5">
              <Label>Yeni Değer</Label>
              {renderValueInput()}
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            İptal
          </Button>
          <Button onClick={apply} disabled={!field || saving} data-testid="bulk-edit-apply">
            Uygula
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
